import React from 'react';
import styled from 'styled-components';
import * as ReactUltimatePagination from 'react-ultimate-pagination';

import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import Icon from 'shared/components/presentational/Icons';
import { FONT_FAMILIES } from 'shared/constants/theme';

const ArrowButton = styled.button`
  color: var(--icons-default);
  display: flex;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
`;

const ArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
`;

const EllipsisButton = styled.button`
  font-family: ${FONT_FAMILIES.brand};
  color: var(--text-light);
  margin: 0 10px;
  cursor: pointer;
`;

const PageButton = styled.button`
  color: ${props =>
    props.isActive ? 'var(--text-default)' : 'var(--text-light)'};
  font-family: ${FONT_FAMILIES.brand};
  cursor: pointer;
`;

const Wrapper = styled.div`
  background-color: var(--surface-primary);
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  height: 100px;
  ${mediaQueries.toTablet`
    height: 70px;
  `};

  *:not(${EllipsisButton}):not(${ArrowWrapper}) + ${PageButton}:before {
    content: '.';
    color: var(--text-light);
    margin: 0 10px;
  }
`;

const renderEllipsisButton = props => (
  <EllipsisButton onClick={props.onClick} disabled={props.disabled}>
    ...
  </EllipsisButton>
);

const renderFirstButton = () => null;

const renderLastButton = () => null;

const renderPageButton = ({ onClick: handleClick, isActive, value }) => (
  <PageButton onClick={handleClick} isActive={isActive}>
    {value}
  </PageButton>
);

const renderPrevButton = ({ onClick: handleClick, isActive: isHidden }) => (
  <ArrowWrapper>
    <ArrowButton onClick={handleClick}>
      {!isHidden && <Icon name="ArrowLeft" />}
    </ArrowButton>
  </ArrowWrapper>
);

const renderNextButton = ({ onClick: handleClick, isActive: isHidden }) => (
  <ArrowWrapper>
    <ArrowButton onClick={handleClick}>
      {!isHidden && <Icon name="ArrowRight" />}
    </ArrowButton>
  </ArrowWrapper>
);

const itemTypeToComponent = {
  PAGE: renderPageButton,
  ELLIPSIS: renderEllipsisButton,
  FIRST_PAGE_LINK: renderFirstButton,
  PREVIOUS_PAGE_LINK: renderPrevButton,
  NEXT_PAGE_LINK: renderNextButton,
  LAST_PAGE_LINK: renderLastButton
};

// https://github.com/ultimate-pagination/react-ultimate-pagination
const ListPagination = ReactUltimatePagination.createUltimatePagination({
  itemTypeToComponent,
  WrapperComponent: Wrapper
});

export default props => <ListPagination hideFirstAndLastPageLinks {...props} />;
